import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export const SUPPORTED_LOCALES = ["en", "fr"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

function normalizePath(pathname: string): string {
  if (!pathname) return "/";
  if (!pathname.startsWith("/")) return `/${pathname}`;
  return pathname;
}

export function localeFromPath(pathname: string): Locale {
  const normalized = normalizePath(pathname).replace(/\/+/g, "/");
  const segments = normalized.split("/").filter(Boolean);
  if (segments.length === 0) {
    return DEFAULT_LOCALE;
  }
  const candidate = segments[0]?.toLowerCase();
  if (candidate && SUPPORTED_LOCALES.includes(candidate as Locale)) {
    return candidate as Locale;
  }
  return DEFAULT_LOCALE;
}

export function useLocale(): Locale {
  const { pathname } = useLocation();
  return useMemo(() => localeFromPath(pathname), [pathname]);
}
